import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Spin, Tooltip } from 'antd'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { slices } from 'store/slices'

import { Wrapper } from './styled'
import useValidations from './hooks/useEvaluationIsValid'
import useSave from './hooks/useSave'

interface IProps {
  evaluationId?: number | null
  close: () => void
}

const Buttons = ({ evaluationId, close }: IProps) => {
  const { t } = useTranslation()
  const appDispatch = useAppDispatch()
  const translationPrefix = 'administration.blocks.type.questionBankV2.buttons'
  const [secondaryButton, setSecondaryButton] = useState('')
  const [primaryButton, setPrimaryButton] = useState('')
  const stage = useAppSelector(slices.questionBank.stage)

  const { evaluationIsValid, tooltip } = useValidations()

  const canContinue = useMemo(() => evaluationIsValid(), [evaluationIsValid])

  useEffect(() => {
    if (stage === 0) {
      setSecondaryButton(t(`${translationPrefix}.cancel`))
      setPrimaryButton(t(`${translationPrefix}.next`))
    } else {
      setSecondaryButton(t(`${translationPrefix}.previous`))
      setPrimaryButton(
        t(
          `${translationPrefix}.${
            evaluationId ? 'updateEvaluation' : 'createEvaluation'
          }`
        )
      )
    }
  }, [stage, evaluationId, t])

  const previous = () => {
    if (stage === 0) {
      close()
    } else {
      appDispatch(slices.questionBank.setStage(0))
    }
  }
  const { saveData, isProcessing } = useSave({ evaluationId, close })

  const next = () => {
    if (canContinue) {
      if (stage === 0) {
        appDispatch(slices.questionBank.setStage(1))
      } else {
        saveData()
      }
    }
  }

  return (
    <Wrapper>
      <Button onClick={previous}>{secondaryButton}</Button>
      <Spin spinning={isProcessing}>
        <Tooltip
          title={tooltip}
          getPopupContainer={() =>
            document.getElementById('lmsPage') as HTMLElement
          }
        >
          <Button onClick={next} disabled={!canContinue}>
            {primaryButton}
          </Button>
        </Tooltip>
      </Spin>
    </Wrapper>
  )
}

export default Buttons
